import { useFlag } from '../../services/launchDarkly';

import { DialogOldDesign } from './DialogOldDesign/Dialog';
import { DialogUiRedesign } from './DialogUiRedesign/Dialog';
import type { IDialogProps } from './types';

export function Dialog(props: IDialogProps) {
  const isNewDesignActive = useFlag('ui_redesign_dialogs', false);

  if (props.forceNewDialogStyle || (isNewDesignActive && props.newDialogStyleEnabled)) {
    return <DialogUiRedesign {...props} />;
  } else {
    return <DialogOldDesign {...props} />;
  }
}
